import { FC, useContext, useEffect } from 'react';

import { Select, Tabs } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';

import { IChartBlockProps } from '../interface';
import s from './ChartBlock.module.scss';
import { useHostOptions, useTypeOptions } from './utils';

export const ChartBlock: FC<IChartBlockProps> = ({
  type,
  setType,
  hostGroupsData,
  selectedHostGroup,
  setSelectedHostGroup,
  selectedHost,
  setSelectedHost,
}) => {
  const { t } = useContext(LocalizationContext);
  const TYPE_OPTIONS = useTypeOptions();
  const { hostOptions, hostGroupOptions } = useHostOptions(
    hostGroupsData,
    selectedHostGroup,
    selectedHost
  );

  useEffect(() => {
    if (selectedHostGroup === null) {
      setSelectedHost(null);
    }
  }, [selectedHostGroup]);
  return (
    <div className={s.wrapper}>
      <div className={s.controls}>
        <Tabs
          options={TYPE_OPTIONS}
          onChange={setType}
          value={type}
          className={s.tabs}
        />
        <div className={s.select_block}>
          <Select
            name="hostGroup"
            options={hostGroupOptions}
            value={selectedHostGroup}
            onChange={setSelectedHostGroup}
            bordered
            placeholder={t('groups.all')}
            className={s.select}
          />
          <Select
            name="hostId"
            options={hostOptions}
            value={selectedHost}
            onChange={setSelectedHost}
            bordered
            placeholder={t('applicationsReport.host.placeholder')}
            className={s.select}
          />
        </div>
      </div>
    </div>
  );
};
